<template>
  <div class="body fixed mobile">
    <!-- class: fixed, mobile -->
    <!-- Header -->
    <section class="header index">
      <a class="left" @click.prevent="$router.push('/record')">
        <img class="logo" src="@/assets/img/favicon.svg" />
        <span class="primary">{{ displayUserPointBalance }}</span>
      </a>
      <div class="uide-page-name">會員服務</div>
      <div class="right">
        <!-- <a class="icon iconButton" @click.prevent="barcodePopupOpen = true"> -->
        <a class="icon iconButton" @click.prevent="$router.push('/barcode')">
          <!-- <font-awesome-icon icon="fa-solid fa-barcode" size="xl"></font-awesome-icon> -->
          <img src="@/assets/img/barcode.svg" />
        </a>
        <!-- <NotificationBell
          v-if="triggerCountUnread"
          @count-unread="countUnread = $event"
        /> -->
      </div>
    </section>
    <!-- Main -->
    <section class="main profile main-no-x-padding">
      <!-- 個人資訊 -->
      <div class="main-x-padding">
        <div class="uide-profile-member mt-2">
          <div class="flex-7 flex flex-row">
            <div class="flex-2 flex items-center">
              <img
                width="40px"
                v-if="displayUserImage()"
                :src="displayUserImage()"
              />
              <img height="40px" class="circle" v-else src="@/assets/img/avatar_yunlin.jpg" />
            </div>
            <div class="flex-8">
              <div class="cNeutral900 font-medium text-lg">
                {{ displayName() }}
              </div>
              <div class="cNeutral500 fS">數位縣民 {{ phoneNumber }}</div>
            </div>
          </div>

          <div class="flex-3 flex items-center gap-4 justify-right">
            <a @click.prevent="$router.push('/profile/edit')">
              <img width="24px" src="@/assets/icon/uide/edit.svg" />
            </a>
            <a @click.prevent="$router.push('/barcode')">
              <img width="24px" src="@/assets/icon/uide/space.svg" />
            </a>
          </div>
        </div>
        
        <a
          class="uide-profile-invite-btn mt-4"
          v-show="displayReferralCode()"
          @click.prevent="openReferralPopup"
        >
          <div class="flex flex-row gap-1">
            <span class="text-white fS"
              >推薦好友註冊雲林幣成功，送雲林幣</span
            ><img width="20px" src="@/assets/icon/uide/coin-gold.svg" />
          </div>

          <img width="24px" src="@/assets/icon/uide/chevron.svg" />
        </a>
      </div>

      <!-- <a
        v-if="!enableStamp"
        class="point flexH between end"
        @click.prevent="$router.push('/record')"
      >
        <div class="flexH">
          <div class="img">
            <img src="@/assets/icon/point.svg" />
          </div>
          <div class="flexV">
            <span class="fM">雲林幣扭一下</span>
            <span class="fXL primary"
              >{{ displayUserPointBalance
              }}<span class="fM primary">點</span></span
            >
          </div>
        </div>
        <div class="flexV" v-if="displayDate">
          <span class="fS">點數到期日</span>
          <span class="fS">{{ displayDate }}</span>
        </div>
      </a> -->

      <div class="uide-profile-board mt-4">
        <div class="text-c03 font-medium fL">雲林幣</div>
        <div class="grid grid-3 gap-3 mb-4 rounded-bg1">
          <RouterLink to="/coin-rule" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-01.svg" />
              <div class="cNeutral900 fM">雲林幣規則</div>
            </div>
          </RouterLink>
          <RouterLink to="/record" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-02.svg" />
              <div class="cNeutral900 fM">交易紀錄</div>
            </div>
          </RouterLink>
          <RouterLink to="/send" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-03.svg" />
              <div class="cNeutral900 fM">轉贈雲林幣</div>
            </div>
          </RouterLink>
          <RouterLink v-if="enableSocialWelfare" to="/ylid-validation" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-10.svg" />
              <div class="cNeutral900 fM">YLID 驗證</div>
            </div>
          </RouterLink>
          <a v-if="enableDDwallet" href="javascript:void(0)" @click="openDDwallet" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-11.svg" />
              <div class="cNeutral900 fM">跨域點數</div>
            </div>
          </a>
        </div>
        <template v-if="storeAdminUrl">
          <div class="text-c03 font-medium fL">特約商店申請及管理</div>
          <div class="grid grid-3 gap-3 mb-4 rounded-bg1">
            <a
              class="flex flex-1 justify-center rounded-lg"
              @click.prevent="linkClickHandler(ssoMerchantApplyUrl)"
            >
              <div class="text-center">
                <img width="48" src="@/assets/icon/uide/profile-04.svg" />
                <div class="cNeutral900 fM">特店申請</div>
              </div>
            </a>
            <a
              v-if="storeList.length > 0"
              class="flex flex-1 justify-center rounded-lg"
              :title="storeAdminUrl"
              @click.prevent="$router.push('/merchant')"
            >
              <div class="text-center">
                <img width="48" src="@/assets/icon/uide/profile-05.svg" />
                <div class="cNeutral900 fM">特店管理後台</div>
              </div>
            </a>
          </div>
        </template>
        <div class="text-c03 font-medium fL">社會福利專區</div>
        <div class="grid grid-3 gap-3 mb-4 rounded-bg1">
          <RouterLink to="/ezcard-binding-moovo" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-10.svg" />
              <div class="cNeutral900 fM">公共自行車<br />回饋試辦計畫</div>
            </div>
          </RouterLink>
          <RouterLink to="/ezcard-binding-tpass" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-09.svg" />
              <div class="cNeutral900 fM">長者<br />乘車補貼</div>
            </div>
          </RouterLink>
        </div>
        <div class="text-c03 font-medium fL">系統相關</div>
        <div class="grid grid-3 gap-3 mb-4 rounded-bg1">
          <router-link
            to="/customer-service"
            class="flex flex-1 justify-center rounded-lg"
          >
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-06.svg" />
              <div class="cNeutral900 fM">聯絡客服</div>
            </div>
          </router-link>
          <a href="/setting" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-07.svg" />
              <div class="cNeutral900 fM">設定</div>
            </div>
          </a>
          <RouterLink to="/e11" class="flex flex-1 justify-center rounded-lg">
            <div class="text-center">
              <img width="48" src="@/assets/icon/uide/profile-08.svg" />
              <div class="cNeutral900 fM">文字大小</div>
            </div>
          </RouterLink>
          <!-- <div class="flex flex-1 justify-center rounded-lg" @click="logout">
            <div class="text-center">
              <div class="p-1">
                <font-awesome-icon :icon="['fas', 'right-from-bracket']" size="2x" color="#6B2DF5" />
              </div>
              <div class="cNeutral900 fM">登出</div>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <!-- Popup (邀請碼) -->
    <ReferralPopup ref="referralPopupRef" />
    <!-- Popup (Code) -->
    <BarcodePopup
      v-if="barcodePopupOpen"
      @closePopup="barcodePopupOpen = false"
    />
    <section id="popLeave" class="popup">
      <div class="popBody">
          <a class="close" @click.prevent="closeLeaveModal"
              ><font-awesome-icon
                  icon="fas fa-times"
              ></font-awesome-icon
          ></a>
          <section class="popHeader">
              <!-- <span class="fL">Title</span> -->
          </section>
          <section class="popMain">
              <div class="fL text-center">提示</div>
              <div class="icon">
              </div>
              <span class="">您即將離開 App 前往外部連結，請問是否繼續？</span>
          </section>
          <section class="popFooter flex">
              <a
                  class="button bg-transparent text-black border border-primary flex-1  submit rounded"
                  @click.prevent="closeLeaveModal"
                  >返回</a
              >
              <a
                  class="button flex-1 submit rounded"
                  @click.prevent="goOut()"
                  ><span class="fM">確認</span></a
              >
          </section>
      </div>
    </section>
    <AlertDialog
      v-if="showAlert"
      :title="alert.title"
      :content="alert.message"
      @close="onCloseAlertDialog"
    />
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapState, mapGetters } from "vuex";
// import NotificationBell from "@/components/NotificationBell.vue";
import BarcodePopup from "@/components/BarcodePopup.vue";
import ReferralPopup from '@/components/ReferralPopup.vue';
import AlertDialog from '@/components/Dialog/AlertDialog.vue';
import { ddwallet } from "@/services/ddwallet.js";
import { stores } from "@/services/stores.js";
import { ssourlSeamless } from "@/services/ssourl/src/index.js";
import { buildUrlQuery } from "@/utils/url.js";

export default {
  name: "Profile",
  components: {
    // NotificationBell,
    BarcodePopup,
    ReferralPopup,
    AlertDialog
  },
  data() {
    return {
      apiHost: process.env.VUE_APP_API_HOST,
      merchantId: process.env.VUE_APP_MERCHANT_ID,
      appHost: process.env.VUE_APP_HOST + process.env.BASE_URL,
      storeAdminHost: process.env.VUE_APP_STORE_ADMIN_URL,
      myReferralCode: "",
      isNotificationBar: false,
      notificationBarContent: {
        title: "",
        message: "",
        time: "",
        points: "",
        reset: function () {
          this.title = "";
          this.message = "";
          this.time = "";
          this.points = "";
        },
      },
      firstNotification: {},
      userData: {},
      stampCards: [],
      tickets: [],
      barcodePopupOpen: false,
      nextUrl: '',
      showAlert: false,
      alert: {
        title: '',
        message: ''
      },
      storeList: [],
      ssoConfig: {
        merchant: {
          endpoint: process.env.VUE_APP_MGR_CORE_HOST,
          vendorId: process.env.VUE_APP_MGR_CORE_VENDER_ID,
          platformId: process.env.VUE_APP_MGR_CORE_PLATFORM_ID,
          projectId: process.env.VUE_APP_MGR_CORE_PROJECT_ID,
          appId: process.env.VUE_APP_MGR_CORE_APP_ID,
          appSecret: process.env.VUE_APP_MGR_CORE_APP_SECRET,
          replyToken: '',
          shortApiId: process.env.VUE_APP_MGR_CORE_SHORT_API_ID
        }
      },
      ssoRedirectUrls: {
        merchant: {
          applyUrl: process.env.VUE_APP_MGR_CORE_MERCHANT_APPLY_URL
        }
      },
      ssoMerchantApplyUrl: ''
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   // called before the route that renders this component is confirmed.
  //   // does NOT have access to `this` component instance,
  //   // because it has not been created yet when this guard is called!
  //   console.log(to, from);
  //   next((vm) => {
  //     let that = vm;
  //     console.log("user: ", that.user);
  //     if (that.user && that.user.userId) {
  //       vm.getUserPoints()
  //         .then((res) => {
  //           that.$store.commit("updateUserPoints", res);
  //         })
  //         .catch((err) => {
  //           console.log("err: ", err);
  //           next("/error");
  //         });
  //       vm.$store.commit(
  //         "updateUserInfo",
  //         Object.assign({}, vm.userInfo, {
  //           myReferralCode: vm.user.user.myReferralCode,
  //         })
  //       );
  //       vm.myReferralCode = vm.user.user.myReferralCode;
  //     } else {
  //       next("/error");
  //     }
  //   });
  // },
  mounted() {
    this.$store.dispatch('getUserPoints');

    if (this.user)
    {
      this.fetchStoreList();
      this.generateSSOLink();
    }
  },
  computed: {
    ...mapState(["user", "userInfo", "currentPath"]),
    ...mapGetters({
      userPoints: "getTyUserPoints",
    }),
    user() {
      return this.$store.state.user;
    },
    enableSocialWelfare() {
      return process.env.VUE_APP_ENABLE_NEW_FEATURES === 'true';
    },
    enableDDwallet() {
      return process.env.VUE_APP_ENABLE_DDWALLET === 'true';
    },
    storeAdminUrl() {
      return process.env.VUE_APP_STORE_ADMIN_URL;
    },
    displayDate() {
      return this.lastestEndOfPoint
        ? this.tsToData(this.lastestEndOfPoint.endTs)
        : "";
      // return this.tsToData(
      //     this.userPoints &&
      //         this.userPoints.pointPeriods &&
      //         this.userPoints.pointPeriods.length > 0
      //         ? this.userPoints.pointPeriods[0].endTs
      //         : null
      // );
    },
    version() {
      return process.env.PACKAGE_VERSION;
    },
    displayUserPointBalance() {
      return this.userPoints && this.userPoints.pointBalance
        ? this.userPoints.pointBalance
        : 0;
    },
    lastestEndOfPoint() {
      if (
        this.userPoints &&
        this.userPoints.pointPeriods &&
        this.userPoints.pointPeriods.length > 0
      ) {
        let sorted = [...this.userPoints.pointPeriods];
        sorted.sort(function (a, b) {
          return a.endTs - b.endTs;
        });
        const latestEndOfPoint = sorted.find((p) => p.endTs >= moment().unix());
        return latestEndOfPoint;
      }
      return null;
    },
    numberOfStampCards() {
      return this.stampCards ? this.stampCards.length : 0;
    },
    numberOfTickets() {
      let ticketSum = 0;
      this.tickets.forEach((product) => {
        ticketSum += product.tickets.filter(
          (ticket) => ticket.status === "pickedup"
        ).length;
      });
      return ticketSum;
    },
    enableStamp() {
      return process.env.VUE_APP_ENABLE_STAMP === "true";
    },
    phoneNumber() {
      return this.user.user._json.phoneNumber
    }
  },
  watch: {
    user(value) {
      if (value)
      {
        this.fetchStoreList();
        this.generateSSOLink();
      }
    }
  },
  methods: {
    goOut() {
      this.closeLeaveModal()
      window.open(this.nextUrl, '_blank', 'noopener,noreferrer');
    },
    linkClickHandler(url) {
      this.openLeaveModal();
      this.nextUrl = url;
    },
    openLeaveModal() {
      const wrap = document.querySelector('#popLeave')
      wrap.style.display = 'flex'
    },
    closeLeaveModal() {
      const wrap = document.querySelector('#popLeave')
      wrap.style.display = 'none'
    },
    openReferralPopup() {
      this.$refs.referralPopupRef.openPop();
    },
    dummyUserData() {
      let result = {
        memberId: 47,
        uuid: null,
        oauthId: "U38a079aadef4a60ec5a6263112248b35",
        picture:
          "https://profile.line-scdn.net/0hNwmZpXdREVhQIzrAyWRuD2xmHzUnDRcQKEJdOHIlGmt1RFIHOEFXPSUiH2x4EFIHaBZebiErSW4p",
        idno: "H223292882",
        name: "Kay Lai",
        birthdate: "1988-03-05",
        phoneNumber: "0921185084",
        carrier: null,
        gender: 1,
        email: "clearsky0305@gmail.com",
        fullAddress: "桃園市平鎮區",
        isTyCitizen: 1,
        createdTs: 1647945287,
      };
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ data: result });
        }, 300);
      });
    },
    callUserDataAPI() {
      var config = {
        method: "get",
        url: `${this.apiHost}/identities/v1/merchants/${this.merchantId}/members/${this.user.userId}`,
        headers: {},
      };

      return this.$http(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          return response;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getUserData() {
      this.callUserDataAPI()
        // this.dummyUserData()
        .then((res) => {
          this.userData = res.data;
        })
        .catch((err) => {
          console.log("err: ", err);
          this.$router.push("/error");
        });
    },
    displayReferralCode() {
      return this.user.user.myReferralCode;
    },
    displayName() {
      return this.userInfo.name;
    },
    displayUserImage() {
      return this.userInfo ? this.userInfo.picture : "";
    },
    tsToData(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD");
    },
    getUserPoints() {
      var config = {
        method: "get",
        url: `${this.apiHost}/points/v1/merchants/${this.merchantId}/members/${this.user.userId}/points`,
        headers: {},
      };

      return this.$http(config)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    generateReferralCode() {
      return this.myReferralCode;
    },
    generateReferralUrl() {
      return encodeURIComponent(
        `${this.appHost}?referralCode=${this.myReferralCode}&openExternalBrowser=1`
      );
    },
    shareWithLINEUrl() {
      return `https://line.me/R/share?text=${this.generateReferralUrl()}`;
    },
    getPointHandler(event) {
      console.log("get points: ", event);
      this.updateUserPoints();
    },
    updateUserPoints() {
      this.getUserPoints()
        .then((res) => {
          console.log("update user points!");
          this.$store.commit("updateUserPoints", res);
        })
        .catch((err) => {
          console.log("err: ", err);
          this.router.push("/error");
        });
    },
    logout() {
      qcsso
        .logout({
          logoutRedirectUri: this.appHost.substring(0, this.appHost.length - 1),
        })
        .then(() => {
          window.Yunlin?.postMessage(JSON.stringify({ type: "logout" }))
          window.flutter_inappwebview?.callHandler('Yunlin', JSON.stringify({ type: "logout" }));
        })
        .catch((err) => console.log(err)).finally(() => {
          console.log("JS Interface", { type: "logout" })
        })
    },
    callGetStampCardsAPI() {
      let config = {
        // url: `${this.apiHost}/stamps/v1/merchants/${this.merchantId}/collector/${this.user.userId}/stamp-cards`
        url: `${this.apiHost}/stamps/v1/merchants/${this.merchantId}/stamp-cards?uuid=${this.user.userId}`,
      };
      console.log("config: ", config);
      return this.$http(config);
    },
    getStampCards() {
      this.callGetStampCardsAPI()
        .then((res) => {
          this.stampCards = res.data;
          console.log("callGetStampCardsAPI: ", res.data);
        })
        .catch((err) => console.log(err));
    },
    callGetTicketsAPI() {
      let config = {
        url: `${this.apiHost}/tickets/v1/merchants/${this.merchantId}/members/${this.user.userId}/tickets`,
      };
      return this.$http(config);
    },
    getTickets() {
      this.callGetTicketsAPI()
        .then((res) => {
          this.tickets = res.data;
        })
        .catch((err) => console.log(err));
    },
    async openDDwallet() {
      try {
        let accountLinkCheckResult = await ddwallet.getAccountLinkCheck(this.merchantId, this.user.userId);
        accountLinkCheckResult = ddwallet.useData(accountLinkCheckResult, 'ddwallet.getAccountLinkCheck');

        if (accountLinkCheckResult.data != null)
        {
          let accountLinkResult = await ddwallet.postAccountLink(this.merchantId, this.user.userId);
          accountLinkResult = ddwallet.useData(accountLinkResult, 'ddwallet.postAccountLink');

          if (accountLinkResult.data.linkUri)
          {
            this.openLeaveModal();

            // Add openExternalBrowser query string for app webview detect need open device browser.
            this.nextUrl = buildUrlQuery(accountLinkResult.data.linkUri, { openExternalBrowser: 1 });
          }
        }
        else
        {
          this.$router.push('/ddwallet-agreement');
        }
      }
      catch (err)
      {
        console.error(err);
        this.alert = {
          title: '',
          message: '跨域點數服務暫時無法使用，請稍後再試。'
        };

        this.showAlert = true;
      }
    },
    onCloseAlertDialog() {
      this.showAlert = false;
      
      this.alert = {
        title: '',
        message: ''
      }
    },
    fetchStoreList() {
      stores.getStoreList(this.user.user.id)
        .then((res) => {
          this.storeList = stores.useData(res);
        })
        .catch((err) => {
          console.error(err);
          console.log('無法取得商店列表資料');
        });
    },
    async generateSSOLink() {
      try {
        const seamless = new ssourlSeamless(this.ssoConfig.merchant);
          
        this.ssoMerchantApplyUrl = await seamless.genurl(this.ssoRedirectUrls.merchant.applyUrl, {
          userId: this.user.userId,
          userToken: '',
          userName: this.user.displayName,
          userPhone: this.user.phone,
          userEmail: (this.user.user.email ? this.user.user.email : '')
        });
      } catch (err) {
        console.error('Error generating SSO URL:', err);
      }
    }
  },
};
</script>

<style scoped>
.version {
  font-size: 0.5rem;
  color: #8080807a;
}
.circle {
  clip-path: circle(20px at center);
}
.rounded-bg1 {
  background-color: #ece5ff; /* Change this to your desired color */
  border-radius: 20px; /* Adjust the radius as needed */
  padding: 0.6rem; /* Optional: Add padding for better appearance */
}
.rounded-top-bg1 {
  background-color: #ece5ff; /* Change this to your desired color */
  border-radius: 20px 20px 0 0; /* Adjust the radius as needed */
  padding: 0.6rem; /* Optional: Add padding for better appearance */
}
.rounded-bottom-bg1 {
  background-color: #ece5ff; /* Change this to your desired color */
  border-radius: 0 0 20px 20px; /* Adjust the radius as needed */
  padding: 0.6rem; /* Optional: Add padding for better appearance */
}
</style>
